import CommonError from '@/common/utils/errors/CommonError';

export default class NoInjectError extends CommonError {
  constructor() {
    super('No inject error', 'No inject error');
  }
}
